/**
 * Énumérations du module ventes — devis (épopée E11).
 * Référence : document 04 § 5.5 (`quotes`, `quote_lines`) ; document 09 § 11.
 */
/** Statuts d'un devis (`quotes.status`). */
export const QUOTE_STATUSES = [
    'draft',
    'sent',
    'viewed',
    'accepted',
    'refused',
    'expired',
    'invoiced',
    'cancelled',
];
/** Mode d'affichage du document imprimé (`quotes.display_mode`). */
export const QUOTE_DISPLAY_MODES = ['short', 'long'];
/** Nature d'une ligne de devis (`quote_lines.line_type`). */
export const QUOTE_LINE_TYPES = ['item', 'text_block', 'section', 'subtotal', 'free'];
//# sourceMappingURL=quote.enum.js.map